// extracted by mini-css-extract-plugin
module.exports = {"root":"root___1tEWu","header":"header___2KxMg","searchIcon":"searchIcon___3LFvk","clearIcon":"clearIcon___3WRuN","cancel":"cancel___3gC4X","loading":"loading___2zlod"};